
import React , { useState  , useEffect , useContext} from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import Swal from 'sweetalert2';
import  { WebAssetsContext }  from "../../../App";

const  Orderstatus = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const [disabled, setDisabled] = useState(false);
  const [variant, setVariant] = useState(null);
  const [activestatus, setActivestatus] = useState(props.status);
  const  renderSwitch = ()  => {
    switch(activestatus) {
      case 'Pending':
        setVariant('danger')
        setActivestatus('Pending')
        return true;
      case 'Completed':
        setVariant('success')
        setActivestatus('Completed')
        return true;
      default:
        setVariant('dark')
        setActivestatus('Cancelled')
    }
  }

  const  updateStatus = async (selectedStatus)  => {
    setDisabled(true);
   
    try {
      let res = await fetch(api+"updateOrderStatus", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: props.orderid,
          status: selectedStatus,
        }),
      });
      let output = await res.json();
      if (res.status === 200) {
        if(output.status === true)
          {
            setActivestatus(selectedStatus)
            Swal.fire({  
                    title: 'Success',  
                    text: 'Order status updated successfully!',
                    icon: 'success'
                  }).then((result) => {
                    
                  });
          }
          setDisabled(false);
      }
    }catch (err) {
      setDisabled(false);
    }

  
  }

  useEffect(() => {
    renderSwitch();
  },[activestatus])
 
  return (
    <>
          
          <Dropdown>
            <Dropdown.Toggle variant={variant}>
                  {activestatus} { disabled == true ? <i className="fas fa-circle-notch fa-spin"></i> : '' } 
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={()=>updateStatus('Completed')}>Completed</Dropdown.Item>
              <Dropdown.Item onClick={()=>updateStatus('Pending')} >Pending</Dropdown.Item>
              <Dropdown.Item onClick={()=>updateStatus('Cancelled')} >Cancelled</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        
    </>

  );
}

export default Orderstatus;


